export default __webpack_public_path__ + "80954f2c8e640d2172d8dd86fd470fd5.png";